module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_DOUBLE COATING_deskstop.a6d16da8.jpg";